import { PeriodBehavior } from '@fabric-ui/components';
import { TimeBucket } from '@fabric-ui/components/Table';
import { PolicyType } from '../PolicyFiltersComponents/types';

export const policyPopProjName = 'uber_policy_populations';
export const expandedSuffix = '_expanded';
export const breakdownSuffix = '_breakdown';
export const sortSuffix = '_sort';

const defaultTimeRange = {
  relative: {
    periodBehaviour: PeriodBehavior.last,
    value: 3,
    unit: 'MONTHS',
  },
};

export const policyComplianceDefaultFilter = {
  dateGap: TimeBucket.BUCKET_WEEK,
  dateObject: defaultTimeRange,
};

export const getFormattingRuleIdByPolicyId = (policies: PolicyType[], policyId: string) =>
  (policies.find(v => v.id === policyId) as PolicyType)?.clientConfig?.formattingRule?.id;
